import React from "react";
import { Layout as RaLayout, Sidebar } from "react-admin";
import TreeMenu from "@bb-tech/ra-treemenu";

const theme = {
  palette: {
    primary: {
      main: "#e60000",
    },
    secondary: {
      light: "#ffe066",
      main: "#ffcc00",
      dark: "#cca300",
      contrastText: "#fff",
    },
    background: {
      default: "#fcfcfe",
    },
  },
  shape: {
    borderRadius: 10,
  },
  overrides: {
    RaMenuItemLink: {
      root: {
        borderLeft: "3px solid #fff",
      },
      active: {
        borderLeft: "3px solid #e60000",
      },
    },
    MuiPaper: {
      elevation1: {
        boxShadow: "none",
      },
      root: {
        border: "1px solid #e0e0e3",
        backgroundClip: "padding-box",
      },
    },
    MuiButton: {
      contained: {
        backgroundColor: "#fff",
        color: "#e60000",
        boxShadow: "none",
      },
    },
    MuiAppBar: {
      colorSecondary: {
        color: "#fff",
        backgroundColor: "#e60000",
      },
    },
    MuiLinearProgress: {
      colorPrimary: {
        backgroundColor: "#f5f5f5",
      },
      barColorPrimary: {
        backgroundColor: "#d7d7d7",
      },
    },
    MuiFilledInput: {
      root: {
        backgroundColor: "rgba(0, 0, 0, 0.04)",
        "&$disabled": {
          backgroundColor: "rgba(0, 0, 0, 0.04)",
        },
      },
    },
  },
};

/**
 * Layout component
 * @param props Component props
 */
export const Layout: React.FC = props => (
  <RaLayout {...props} sidebar={Sidebar} theme={theme} menu={TreeMenu} />
);
